/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgLayersTwo02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 18 18"
    data-name="SvgLayersTwo02"
    {...props}
  >
    {props.children}
    <clipPath id="layers-two-02_svg__a">
      <path d="M0 0h18v18H0z" />
    </clipPath>
    <g clipPath="url(#layers-two-02_svg__a)">
      <path
        stroke="#0d0d0d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M2.25 8.318v1.463m13.5-1.463v1.544M1.5 4.612l7.232-3.524c.098-.048.147-.072.199-.082a.4.4 0 0 1 .138 0c.052.01.1.034.2.082L16.5 4.613 9.268 8.138c-.098.048-.147.072-.199.081a.4.4 0 0 1-.138 0c-.052-.01-.1-.033-.2-.081zm0 8.775 7.232-3.525c.098-.048.147-.072.199-.081a.4.4 0 0 1 .138 0c.052.01.1.033.2.081l7.231 3.525-7.232 3.525c-.098.048-.147.072-.199.082a.4.4 0 0 1-.138 0c-.052-.01-.1-.034-.2-.082z"
      />
    </g>
  </svg>
)
